<div class="chat_window_main">
  <!-- <div class="no_msg_div" *ngIf="selectedUser && messageList.length==0">
    <img src="/assets/images/no_data_5.png" alt="">
    <p>No Results Found</p>
  </div> -->

  <div class="no_msg_div_new" *ngIf="selectedUser==null">
    <img src="/assets/icon/chat/default_chat_window.png" alt="">
    <p>Kindly select an order to begin chatting with the advisor.</p>
  </div>

  <div class="chat_window" *ngIf="selectedUser">
    <div class="chat_header">
      <div class="user_details">
        <div class="profile_pic">
          <img class="user_img" src="/assets/images/featuretallent.svg"
            onerror="this.src='/assets/images/featuretallent.svg'" alt="">
          <img class="avb_icon" src="/assets/avb_green.svg" alt="">
        </div>
        <div class="user_details_middle">
          <a class="user_name"
            href="javascript:void(0)">{{selectedUser?.orderDetails?.consultantName?selectedUser?.orderDetails?.consultantName:'N/A'}}</a>
          <p class="job_title">{{selectedUser?.orderDetails?.productName}}</p>
        </div>
        <div class="dot_img" (click)="expandChatbox()">
          <img src="/assets/images/card_view_drop.svg" alt="">
        </div>
      </div>
      <div class="chat_header_bottom">
        <div class="header_btns">
          <button *ngIf="selectedUser?.advisorProductOrder?.orderStatus=='COMPLETED'"
            class="view_job view_job_deleted">Order
            Completed</button>
          <button *ngIf="selectedUser?.advisorProductOrder?.orderStatus=='ADVISOR_COMPLETED'"
            class="view_job view_job_deleted"><img src="/assets/icon/chat/pending.svg" alt="">Mark as Completed (Pending
            Verification)</button>
          <button *ngIf="selectedUser?.advisorProductOrder?.orderStatus=='ASSIGNED'" class="view_job"><img
              src="/assets/icon/chat/view_job.png" alt="">In-Progress</button>
          <div class="left_btn_div">
            <button (click)="viewDetails()" *ngIf="selectedUser?.orderDetails" class="view_job"><img
                src="/assets/icon/chat/view_job.png" alt="">View Details</button>
          </div>

        </div>
        <div class="divider">
          <p></p>
        </div>
      </div>
    </div>
    <div *ngIf="selectedUser?.advisorProductOrder" class="chat_msgs_div_main" appScrollToBottom
      [messageList]="messageList">
      <div class="message_card_main" *ngFor="let item of messageList;let i=index;">
        <div class="msg_date_divider"
          *ngIf="i>0  && (item?.createdAt!='' && item?.createdAt!=null) && (messageList[i]?.createdAt | date:'dd/MM/Y')!=(messageList[i-1]?.createdAt | date:'dd/MM/Y') ">
          <div class="divider_line"></div>
          <p>{{item?.createdAt | date:'EE, MMM dd'}}</p>
          <div class="divider_line"></div>
        </div>
        <div class="message_card" [ngClass]="{
            'msg_offer_gap': item?.serviceType,
            'employer_card': item?.sentFrom!==gS.userData?.id
          }">
          <div class="msg_container">
            <div class="profile_pic" *ngIf="item?.sentFrom!==gS?.userData?.id">
              <img class="user_img" src="/assets/images/featuretallent.svg"
                onerror="this.src='/assets/images/featuretallent.svg'" alt="">
              <img class="avb_icon" src="/assets/avb_green.svg" alt="">
            </div>
            <div class="message_body"
              *ngIf="item?.messageType=='TEXT' && !(item?.message.startsWith('https://') || item?.message.startsWith('www.') || item?.message.endsWith('.com') || item?.message.endsWith('.in') || item?.message.startsWith('http://'))">
              <p>{{item?.message}}</p>

            </div>
            <div class="msg_file_card" (click)="clickLink(item.messages)"
              *ngIf="item?.messageType=='TEXT' && (item?.message.startsWith('https://') || item?.message.startsWith('www.')  || item?.message.endsWith('.in')  || item?.message.endsWith('.com') || item?.message.startsWith('http://'))">
              <img src="/assets/icon/chat/link_icon.png" alt="">
              <div class="file_right">
                <a href="javasrcipt:void(0)" target="_blank" class="file_name">{{item.message}}</a>
              </div>
            </div>
            <div class="msg_file_card" (click)="openFileLink(item?.message)" *ngIf="item?.messageType=='FILE'">
              <img src="/assets/icon/chat/file_icon.png" alt="">
              <div class="file_right">
                <p class="file_name">{{item?.fileName?(item?.fileName +
                  '.'+item?.fileExtension):item.message.replace('https://s3.ap-south-1.amazonaws.com', '')}}</p>
              </div>
            </div>
          </div>


          <div class="msg_time">
            <p>{{item?.createdAt?(item?.createdAt| date:' h:mm a'):'12.00 AM'}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="chat_footer" *ngIf="selectedUser?.advisorProductOrder?.orderStatus=='ASSIGNED'">
      <div class="send_msg_div">
        <img (click)="openAttachment($event)" src="/assets/icon/chat/attachment.svg" alt="">

        <ng-container>
          <textarea id="chatTextarea" [(ngModel)]="chatMsg" autocomplete="off" placeholder="Write a message ..."
            (keydown)="keyDownEvent($event)"></textarea>
        </ng-container>

        <img #emojiButton (click)="isEmojiPickerVisible = !isEmojiPickerVisible;" src="/assets/icon/chat/smile_icon.svg"
          alt="">

        <emoji-mart class="emoji-mart" *ngIf="isEmojiPickerVisible" (emojiSelect)="addEmoji($event)"
          title="Choose your emoji"></emoji-mart>
      </div>

      <div class="attachment_div" (appClickOutside)="attachmentOuside()" *ngIf="isAttachmentBox">
        <form [formGroup]="fileAttachmentForm">
          <div class="attach_click_div" *ngIf="!fileAttachmentForm.value.fileUrl && !imageLoader"
            (click)="openAttachmentPicker()">
            <img class="file_icon" src="/assets/icon/chat/attachment_new.svg" alt="">
            <div class="attach_text">
              <p>Attach File</p>
              <span>Up to 25 MB</span>
            </div>
          </div>
          <div class="attachment_divider" *ngIf="!fileAttachmentForm.value.fileUrl && !imageLoader">
            <p></p>
            <span>OR</span>
            <p></p>
          </div>
          <div class="attach_click_div" *ngIf="!fileAttachmentForm.value.fileUrl && !imageLoader"
            (click)="selectFromSavedFile()">
            <img class="file_icon" src="/assets/icon/chat/file_icon.png" alt="">
            <div class="attach_text">
              <p>Send file from saved file</p>
            </div>
          </div>
          <div class="loader" *ngIf="imageLoader"></div>
          <div class="attach_click_div" *ngIf="fileAttachmentForm.value.fileUrl && !imageLoader">
            <img class="file_icon" src="/assets/icon/chat/file_icon.png" alt="">
            <div class="attach_text">
              <p>
                {{checkBox?fileAttachmentForm.value?.fileName:nameWithoutExtension}}.{{fileAttachmentForm.value?.extension}}
              </p>
            </div>
            <img (click)="removeFileAttachment($event)" class="close_icon" src="/assets/images/close_cross.svg" alt="">
          </div>
          <div class="checkboxInputDiv">
            <label for="symbols_2">
              <input type="checkbox" id="symbols_2" class="custom-check-box" name="symbols_2" value="symbols_2"
                [(ngModel)]="checkBox" [ngModelOptions]="{standalone: true}"
                (change)="updateFileNameValidation($event)">
              <label for="symbols_2"></label>
            </label>
            <div class="textDiv">Save file for future use.</div>
          </div>
          <div class="file_name" *ngIf="checkBox && fileAttachmentForm.value.fileUrl && !imageLoader">
            <p>File Name*</p>
            <input formControlName="fileName" maxlength="20" type="text" placeholder="Enter file name">
          </div>
          <div class="file_send_btn" *ngIf="fileAttachmentForm.value.fileUrl && !imageLoader">
            <button [disabled]="!fileAttachmentForm.valid" (click)="sendFile()">Send</button>
          </div>
        </form>
      </div>
      <div class="send_btn">
        <button [disabled]="chatMsg==''" (click)="sendMessage(chatMsg,'TEXT')">Send <img
            src="/assets/icon/chat/send_btn.svg" alt=""></button>
      </div>
    </div>
    <div class="chat_left_slide_main" *ngIf="expandChatFlag==true">
      <div class="slide slide_1" *ngIf="!personalNoteFlag && !filesAttachmentFlag && !searchMessageFlag">
        <div class="slide_1_header">
          <div class="close_btn" (click)="expandChatbox()">
            <img src="/assets/images/close_cross.svg" alt="">
          </div>
          <div class="profile_pic">
            <img class="user_img" src="/assets/images/featuretallent.svg"
              onerror="this.src='/assets/images/featuretallent.svg'" alt="">
            <img class="avb_icon" src="/assets/avb_green.svg" alt="">
          </div>
          <p class="user_name">
            {{selectedUser?.orderDetails?.consultantName?selectedUser?.orderDetails?.consultantName:'N/A'}}</p>
          <div class="job_div">
            <img src="/assets/icon/chat/slide_job.svg" alt="">
            <p>{{selectedUser?.orderDetails?.productName}}</p>
          </div>
        </div>
        <div class="divider">
          <p></p>
        </div>
        <div class="option_card_main">
          <div class="option_card" (click)="searchMessageAction()">
            <img src="/assets/icon/chat/search_icon.svg" alt="">
            <p>Search Messages</p>
            <img src="/assets/icon/chat/right_arrow.svg" alt="">
          </div>
          <div class="option_card" (click)="fileAttachment()">
            <img src="/assets/icon/chat/slide_file_icon.svg" alt="">
            <p>Files and Links</p>
            <img src="/assets/icon/chat/right_arrow.svg" alt="">
          </div>
          <div class="option_card" (click)="showSavedFile()">
            <img src="/assets/icon/chat/note_icon.svg" alt="">
            <p>Saved File</p>
            <img src="/assets/icon/chat/right_arrow.svg" alt="">
          </div>
        </div>
      </div>
      <div *ngIf="filesAttachmentFlag" class="slide slide_2">
        <div class="back_btn" (click)="resetFlag()">
          <img src="/assets/icon/chat/right_arrow.svg" alt="">
          <p>Back</p>
        </div>

        <div class="segment_div_main">
          <div class="segment_div">
            <div class="segement_tab_main" (click)="viewFiles('all')">
              <div class="segement_tab" [ngClass]="fileTypeFilter=='all'?'segement_tab_active':''">
                <p>All</p>
              </div>
            </div>
            <div class="segement_tab_main" (click)="viewFiles('files')">
              <div class="segement_tab" [ngClass]="fileTypeFilter=='files'?'segement_tab_active':''">
                <p>Files</p>
              </div>
            </div>
            <div class="segement_tab_main" (click)="viewFiles('links')">
              <div class="segement_tab" [ngClass]="fileTypeFilter=='links'?'segement_tab_active':''">
                <p>Links</p>
              </div>
            </div>
          </div>
        </div>

        <div class="fileLinkLoop"
          *ngIf="fileTypeFilter=='all' && (messageList | messageFilter:fileTypeFilter).length>0">
          <div class="fileLinkCard" *ngFor="let item of messageList | messageFilter:fileTypeFilter;let i=index;">
            <img class="file_icon"
              [src]="item?.messageType=='FILE'?'/assets/icon/chat/file_icon.png':'/assets/icon/chat/link_icon.png'"
              alt="">
            <div class="fileDetails">
              <a class="file_name" [href]="item?.message" target="_blank">{{(item?.fileName &&
                item?.fileExtension)?(item?.fileName
                +'.'+item?.fileExtension):item?.message.replace('https://s3.ap-south-1.amazonaws.com/','')}}</a>
            </div>
            <div class="sent_time">
              <p>{{item?.createdAt | date:' M/d/Y'}}</p>
            </div>
          </div>
        </div>
        <div class="fileLinkLoop"
          *ngIf="fileTypeFilter=='files'  && (messageList | messageFilter:fileTypeFilter).length>0">
          <div class="fileLinkCard" *ngFor="let item of messageList | messageFilter:fileTypeFilter;let i=index;">
            <img class="file_icon"
              [src]="item?.messageType=='FILE'?'/assets/icon/chat/file_icon.png':'/assets/icon/chat/link_icon.png'"
              alt="">
            <div class="fileDetails">
              <a class="file_name" [href]="item?.message" target="_blank">{{(item?.fileName &&
                item?.fileExtension)?(item?.fileName
                +'.'+item?.fileExtension):item?.message.replace('https://s3.ap-south-1.amazonaws.com/','')}}</a>
            </div>
            <div class="sent_time">
              <p>{{item?.createdAt | date:' M/d/Y'}}</p>
            </div>
          </div>
        </div>
        <div class="fileLinkLoop"
          *ngIf="fileTypeFilter=='links'  && (messageList | messageFilter:fileTypeFilter).length>0">
          <div class="fileLinkCard" *ngFor="let item of messageList | messageFilter:fileTypeFilter;let i=index;">
            <img class="file_icon"
              [src]="item?.messageType=='FILE'?'/assets/icon/chat/file_icon.png':'/assets/icon/chat/link_icon.png'"
              alt="">
            <div class="fileDetails">
              <a class="file_name" [href]="item?.message" target="_blank">{{(item?.fileName &&
                item?.fileExtension)?(item?.fileName
                +'.'+item?.fileExtension):item?.message.replace('https://s3.ap-south-1.amazonaws.com/','')}}</a>
            </div>
            <div class="sent_time">
              <p>{{item?.createdAt | date:' M/d/Y'}}</p>
            </div>
          </div>
        </div>

        <div *ngIf="fileTypeFilter=='all' && (messageList | messageFilter:fileTypeFilter).length==0"
          class="no_data_found">
          <img src="/assets/images/nodatafound.svg" alt="">
          <p>You haven't shared any files or links recently.</p>
        </div>
        <div *ngIf="fileTypeFilter=='files' && (messageList | messageFilter:fileTypeFilter).length==0"
          class="no_data_found">
          <img src="/assets/images/nodatafound.svg" alt="">
          <p>You haven't shared any files recently.</p>
        </div>
        <div *ngIf="fileTypeFilter=='links' && (messageList | messageFilter:fileTypeFilter).length==0"
          class="no_data_found">
          <img src="/assets/images/nodatafound.svg" alt="">
          <p>You haven't shared any links recently.</p>
        </div>
      </div>
      <div class="" *ngIf="personalNoteFlag" class="slide slide_3">
        <div class="back_btn" (click)="resetFlag()">
          <img src="/assets/icon/chat/right_arrow.svg" alt="">
          <p>Back</p>
        </div>
        <div class="personal_note_div">
          <textarea placeholder="Use this space to save your thoughts however you'd like:"></textarea>
        </div>
      </div>
      <div *ngIf="searchMessageFlag" class="slide slide_2 slide_4">
        <div class="back_btn" (click)="resetFlag()">
          <img src="/assets/icon/chat/right_arrow.svg" alt="">
          <p>Back</p>
        </div>
        <div class="search_div">
          <img class="search_icon" src="/assets/icon/chat/search_icon.svg" alt="">
          <input [(ngModel)]="msgSearchText" type="text" placeholder="Search">
          <img *ngIf="msgSearchText" class="clear_img" (click)="clearSearch()" src="/assets/images/cloase-search.svg"
            alt="">
        </div>
        <div class="fileLinkLoop" *ngIf="msgSearchText && (messageList | globalSearch:msgSearchText).length>0">
          <div class="fileLinkCard searchMsgFileLinkCard"
            *ngFor="let item of  messageList | globalSearch:msgSearchText">
            <img class="profile_image" src="/assets/images/featuretallent.svg"
              onerror="this.src='/assets/images/featuretallent.svg'" alt="">
            <div class="fileDetails">
              <p class="file_name" *ngIf="item?.messageType=='FILE'">{{(item?.fileName &&
                item?.fileExtension)?(item?.fileName
                +'.'+item?.fileExtension):item?.message.replace('https://s3.ap-south-1.amazonaws.com/','')}}</p>
              <p class="file_name" *ngIf="item?.messageType=='TEXT'">
                {{item?.message.replace('https://s3.ap-south-1.amazonaws.com/','')}}</p>
              <p class="sender_name">{{item?.senderName}}</p>
            </div>
            <div class="sent_time">
              <p>{{item?.createdAt| date:' h:mm a'}}</p>
            </div>
          </div>
        </div>

        <div *ngIf="(msgSearchText=='') || (messageList | globalSearch:msgSearchText).length==0" class="no_data_found">
          <img src="/assets/images/nodatafound.svg" alt="">
          <p>No Results Found</p>
        </div>
      </div>
    </div>

    <div class="chat_no_data_assigned" *ngIf="selectedUser?.advisorProductOrder==null">
      <img src="/assets/icon/chat/default_chat_window.png" alt="">
      <p>An advisor has not yet been assigned to this product. Please wait until an advisor is assigned before
        initiating a chat regarding your product order.</p>
    </div>

    <!-- saved file design -->
    <div class="chat_left_slide_main saved_left" *ngIf="expandSavedFileFlag==true">
      <div class="slide slide_2">
        <div class="back_btn" (click)="resetFlag()">
          <img src="/assets/icon/chat/right_arrow.svg" alt="">
          <p>Saved Files</p>
        </div>
        <div class="search_div">
          <img class="search_icon" src="/assets/icon/chat/search_icon.svg" alt="">
          <input [(ngModel)]="msgSearchText" type="text" placeholder="Search">
          <img *ngIf="msgSearchText" (click)="clearSearch()" class="clear_img" src="/assets/images/cloase-search.svg"
            alt="">
        </div>
        <div class="fileLinkLoop" *ngIf="(savedFileList | globalSearch:msgSearchText).length>0">
          <div class="fileLinkCard" *ngFor="let item of savedFileList | globalSearch:msgSearchText;let i=index;">
            <img class="file_icon" src="/assets/icon/chat/file_icon.png" alt="">
            <div class="fileDetails">
              <a class="file_name" [href]="item?.fileUrl" target="_blank">{{item?.fileName}}.{{item?.fileExtension}}</a>
              <p class="time_text">{{item?.createdAt | date:' M/d/Y'}}</p>
            </div>
            <div class="sent_btn_new" (click)="sendSavedFile(item)">
              <img src="/assets/icon/chat/send_btn.svg" alt="">
            </div>
          </div>
        </div>
        <div class="no_data_found" *ngIf="(savedFileList | globalSearch:msgSearchText)?.length==0">
          <img src="/assets/images/nodatafound.svg" alt="">
          <p>{{msgSearchText?'No data found':'You have not saved any files recently'}}</p>
        </div>
      </div>
    </div>
  </div>
</div>